import { render, staticRenderFns } from "./ModalsForm.vue?vue&type=template&id=038a424c&scoped=true&"
import script from "./ModalsForm.vue?vue&type=script&lang=ts&"
export * from "./ModalsForm.vue?vue&type=script&lang=ts&"
import style0 from "./ModalsForm.vue?vue&type=style&index=0&id=038a424c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038a424c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('038a424c')) {
      api.createRecord('038a424c', component.options)
    } else {
      api.reload('038a424c', component.options)
    }
    module.hot.accept("./ModalsForm.vue?vue&type=template&id=038a424c&scoped=true&", function () {
      api.rerender('038a424c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/ModalsForm.vue"
export default component.exports